import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';

import {map, switchMap, tap, withLatestFrom} from 'rxjs/operators';
import {decrementPublicCount, SellPreviewResponseInterface, SellPreviewRestService} from 'sp-arch-lib';
import * as concludeSellingActions from 'sp-mark/redux/conclude-selling/conclude-selling.actions';
import * as redirectMessageActions from 'sp-mark/feature-modules/redirect-message/redux/redirect-message.actions';
import {routingPathsConstants} from 'sp-mark/models/routing-paths.constants';
import * as routingActions from 'sp-mark/redux/router/router.actions';
import {closeDialog, openDialog} from 'sp-ui-lib';
import {from, iif, of} from 'rxjs';
import * as redirectMessageSelectors from 'sp-mark/feature-modules/redirect-message/redux';

@Injectable()
export class ConcludeSellingEffects {
  executePaymentConcluded$ = createEffect(() =>
    this.actions$.pipe(
      ofType(concludeSellingActions.executePaymentConcluded),
      withLatestFrom(this.appState$.select(redirectMessageSelectors.selectSellResponse)),
      switchMap(([action, sellResponse]) =>
        iif(() => sellResponse?.externalPayment,
          from([
            redirectMessageActions.storeSellResponseStatus({sellResponse: action.sellResponse as SellPreviewResponseInterface}),
            decrementPublicCount(),
            routingActions.navigateTo(routingPathsConstants.REDIRECT_MESSAGE)
          ]),
          from([
            redirectMessageActions.storeSellResponseStatus({sellResponse: action.sellResponse as SellPreviewResponseInterface}),
            decrementPublicCount(),
            routingActions.navigateTo(routingPathsConstants.CONGRATS)
          ])
        ))
    )
  );

  executePaymentFailure$ = createEffect(() =>
    this.actions$.pipe(
      ofType(concludeSellingActions.executePaymentFailure),
      tap(() => this.appState$.dispatch(decrementPublicCount())),
      map(() =>
        openDialog({
          dialogData: {
            title: 'SHARED.DIALOG.ALERT_TITLE',
            message: ['SHARED.DIALOG.TRANSACTION_WENT_KO'],
            buttons: [
              {
                label: 'SHARED.BUTTON.CLOSE',
                icon: '',
                callback: () => this.appState$.dispatch(closeDialog())
              }
            ]
          }
        })
      )
    )
  );

  prepareConcludeSelling$ = createEffect(() =>
    this.actions$.pipe(
      ofType(concludeSellingActions.prepareConcludeSellingAction),
      switchMap(({configuration}) =>
        this.sellPreviewRestService.createRecurrences(configuration).pipe(
          switchMap(response => iif(() => !!response,
            of(routingActions.navigateToConcludeSelling({idOperation: response.operationId})),
            of(openDialog({
              dialogData: {
                title: 'SHARED.DIALOG.ALERT_TITLE',
                message: ['SHARED.DIALOG.TRANSACTION_WENT_KO'],
                buttons: [
                  {
                    label: 'SHARED.BUTTON.CLOSE',
                    icon: '',
                    callback: () => this.appState$.dispatch(closeDialog())
                  }
                ]
              }
            }))
          )),
        )
      )
    )
  );


  constructor(
    private readonly actions$: Actions,
    private readonly sellPreviewService: SellPreviewRestService,
    private appState$: Store,
    private readonly sellPreviewRestService: SellPreviewRestService
  ) {
  }
}
